import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Container } from "@bw/bits"
import { ArrowLeft } from "@bw/icons"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  margin: 45px 0;
  font-weight: 300;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media (min-width: ${breakpoints.medium}px) {
    margin: 20px 0;
  }
`
const ActiveElement = styled.div`
  display: none;
  font-size: 14px;
  font-weight: 500;
  color: #232825;
  line-height: 24px;
  text-decoration: none;

  @media (min-width: ${breakpoints.medium}px) {
    display: inline-block;
    font-size: 14px;

    &:nth-child(n + 2) {
      &:before {
        content: ">";
        display: inline-block;
        margin: 0 8px;
      }
    }
  }
`
const StyledBreadcrumb = styled(Link)`
  display: none;
  font-size: 14px;
  color: #232825;
  line-height: 24px;
  text-decoration: none;

  /* the second last item is the only one visible on smartphones */
  &:nth-last-child(2) {
    display: flex;
    align-items: center;
    font-weight: 500;
    > * {
      margin-right: 10px;
    }

    @media (min-width: ${breakpoints.medium}px) {
      display: inline-block;
      font-weight: 300;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    display: inline-block;
    font-size: 14px;

    svg {
      display: none;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    &:nth-child(n + 2) {
      &:before {
        content: ">";
        display: inline-block;
        margin: 0 8px;
      }
    }
  }
`
const Breadcrumbs = ({ breadcrumbs }) => {
  return (
    <Container>
      <Wrapper>
        {breadcrumbs.map((item, i) => {
          if (i === breadcrumbs.length - 1) {
            return (
              <ActiveElement key={i}>
                {i === breadcrumbs.length - 2 && <ArrowLeft />}
                {item.title}
              </ActiveElement>
            )
          }

          return (
            <StyledBreadcrumb key={i} to={item.to}>
              {i === breadcrumbs.length - 2 && <ArrowLeft />}
              {item.title}
            </StyledBreadcrumb>
          )
        })}
      </Wrapper>
    </Container>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
      active: PropTypes.bool,
    })
  ),
}

Breadcrumbs.defaultProps = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      active: false,
    })
  ),
}

export { Breadcrumbs }
